import inflect from "pluralize";

inflect.addSingularRule("smoothies", "smoothie");
inflect.addSingularRule("cookies", "cookie");

export default inflect;
